import React from 'react'
import { Rows } from 'src/components'
import { mergeProps } from 'src/util'
import styles from './BlockWrapper.scss'

/**
 * The block wrapper component.
 */
const BlockWrapper = ({ ...domProps }) => <Rows {...mergeProps()({ className: styles.wrapper }, domProps)} gap="0" />

export default BlockWrapper
